import { BlogPost } from '../BlogPosts';

export const welcomeToToastie: BlogPost = {
  id: 'welcome-to-toastie',
  image: `${process.env.PUBLIC_URL}/assets/toastie-logo.png`,
  tag: 'Company News',
  title: 'Meet Toastie: Available on iOS & Android',
  date: '30 Jun 2025',
  readTime: '2 min',
  subtitle: "We're officially live on the App Store and Google Play!",
  content: `Hi there, and welcome to the Toastie blog! 👋

We're so excited to share that **Toastie is now live** on the [App Store](https://apps.apple.com/au/app/toastie-health-tracker/id6736644572) and [Google Play](https://play.google.com/store/apps/details?id=au.toastie.health.tracker&hl=en_AU)! 🎉

Toastie is a health tracker built by people living with chronic illness, for people living with chronic illness.

#### ✨ What you can track

- **Symptoms, medications and mood**
- **Meals**, with photo recognition for meals and ingredients
- **Periods, bowel movements and weight**
- **Blood tests, X-rays, medical records and GP visits**
- **Notes**, with speech-to-text and automatic categorisation

#### 🔍 Insights that make sense

Toastie looks across your history to spot trends and connections, like how what you eat might affect how you feel. You can ask questions about your health, and use symptom self-triage to help decide whether to keep monitoring, see a doctor, or seek urgent care.

#### 🩺 Ready for your next appointment

Toastie organises your health history into a clear summary, so it's easier to explain what's been going on to your doctor.

*Toastie's insights aren't medical advice. Always check with your doctor before making medical decisions.*

#### 💖 Support two indie developers

Toastie is built by two indie developers who live with chronic illness ourselves. If Toastie helps you, the best ways to support us are downloading the app, leaving a review, and telling a friend who might need it.

#### 💬 We'd love to hear from you

We're always open to feedback, whether that's a feature you'd love to see or something that isn't working quite right. Get in touch any time at [hello@toastie.au](mailto:hello@toastie.au).

With love,
Anna & Viv 💖🌱`,
};
